<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>出版準備檢查</span>
                        <h1>做好手稿的出版準備</h1>
                        <p>根據20多種標準出版要求評估您的手稿，以更快地通過期刊篩選。Trinka甚至可以讓您查看手稿與目標期刊出版範圍的匹配程度。</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" id="autoEditGetStart" target="_blank">開始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <!-- <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/PublicationReadinessChecksImg.png" alt="">
                    </div> -->
                    <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                        <!-- <img src="../../../assets/images/PublicationReadinessChecksImg.png" alt=""> -->
                        <ul>
                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/JournalScope.svg" alt="">
                                </div>
                                <h3>期刊範圍匹配</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/TechnicalCompliance.svg" alt="technical compliance">
                                </div>
                                <h3>技術合規</h3>
                                <span>3 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/EthicalCompliance.svg" alt="">
                                </div>
                                <h3>道德合規</h3>
                                <span>5 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/AuthorshipDetails.svg" alt="">
                                </div>
                                <h3>作者詳細資訊</h3>
                                <span>4 Checks</span>
                            </li>
                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/ReferenceDetails.svg" alt="reference details">
                                </div>
                                <h3>參考文獻的細節</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/FirgureTable.svg" alt="">
                                </div>
                                <h3>圖表</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/ClinicalTrials.svg" alt="">
                                </div>
                                <h3>臨床試驗資訊</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/KeywordsAndSummary.svg" alt="">
                                </div>
                                <h3>關鍵字和摘要</h3>
                                <span>2 Checks</span>
                            </li>
                            <i></i>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 
    <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>工作原理</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="">
                                </div>
                                <h3>註冊 / 登錄</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>打開/導入文件並選
                                    <br />擇發表準備情況檢查</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>獲取詳細的
                                    <br />評估報告</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="SectionHowItWrok" #viewVideo>
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/PublicationCheckThumbnail.png" alt="publication checks" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何工作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">通過這個簡短的示範影片，瞭解如何使用20多項出版準備檢查並更快地實現出版目標。</p>
                        <p style="margin-bottom: 10px;">這個詳細的分步教程可幫助您充分利用Trinka的強大功能。如果您有更多問題，請在
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">此處</a>瀏覽我們的常見問題解答。</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>出版準備檢查的主要特徵</h2>
                        <div class="HeadingSubLine"></div>
                        <p>使用Trinka的出版準備檢查，您可以透過為出版物準備的20多項檢查來評估您的文檔，並進行修訂以增加發表的機會。</p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/JournalScope.svg" alt="">
                        </div>
                        <h3>期刊範圍匹配</h3>
                        <p>透過檢查您的稿件是否與目標期刊的範圍相匹配並為您推薦其他匹配的期刊，避免稿件被拒。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/TechnicalCompliance.svg" alt="technical compliance">
                        </div>
                        <h3>技術合規</h3>
                        <p>Trinka會檢查幾種標準的出版物要求，例如摘要、字數和原稿章節標題，以確保您的手稿滿足期刊的所有要求。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/EthicalCompliance.svg" alt="">
                        </div>
                        <h3>道德合規</h3>
                        <p>確保您已進行所有強制性聲明，例如知情同意、道德批准、財務披露和利益衝突，以便順利進行編輯審查。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/AuthorshipDetails.svg" alt="">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>作者詳細資訊</h3>
                        <p>檢查大多數期刊所要求的作者詳細資訊，例如作者姓名、隸屬關係，通訊資訊和作者貢獻聲明等等。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/ReferenceDetails.svg" alt="reference details" width="29" height="38">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>參考文獻的細節</h3>
                        <p>Trinka會檢查您的參考文獻並提醒您是否使用了過時的參考文獻。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/FirgureTable.svg" alt="">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>圖表</h3>
                        <p>Trinka會檢查您所有的圖形標題、表格標題及其引用，以確保滿足所有的投稿要求。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/ClinicalTrials.svg" alt="" width="31" height="37">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>臨床試驗資訊</h3>
                        <p>Trinka會檢查您是否提到了任何臨床試驗ID，並獲取有關試驗的資訊，以便您始終可以確保提供正確的詳細資訊。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/KeywordsAndSummary.svg" alt="">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>關鍵字和摘要</h3>
                        <p>Trinka的頂級人工智慧可以為您的論文提供全面的、有代表性的總結，並突出論文的重要主題和概念，它還會為您的稿件建議可能的關鍵字。</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>查看樣本報告</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <!-- <div class="col-sm-2"></div> -->
                <div class="col-sm-12">
                    <div class="viewSampleReportImg">
                        <img src="../../../assets/images/PublicationReportImg.png" alt="publication report">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>檢查您的手稿是否做好出版準備</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">開始使用</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>使用積分及進行出版準備檢查</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/lightbulb.png" alt="light">
                            </span>
                            <p>每個檢查報告將花費1個積分。使用免費積分並根據需要購買更多。</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 10px;">積分就像代幣一樣，可讓您根據需要使用多種Trinka功能。</p>
                            <p>高級用戶每月獲得10個積分，基本用戶每月獲得4個免費積分。要了解更多資訊，請點擊
                                <a [routerLink]="['/features/credits']">此處。</a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常見問題</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        出版準備檢查會消耗多少積分？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>每次運行出版準備檢查都會消耗1個積分。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        我可以下載出版準備檢查報告嗎？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前您無法下載出版準備檢查報告，但是您的報告在Trinka雲上始終可見。您註冊的電子郵件也會收到每個檢查報告的連結。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我能在Trinka的基本計畫中獲得出版準備檢查功能嗎？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，這項功能將消耗積分。基本訂閱用戶每月將獲得4個免費積分，可用於獲取出版準備檢查報告。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        如何使用出版準備檢查報告？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以將出版準備檢查報告作為投稿清單，輕鬆地與目標期刊的要求進行比較，並且輕鬆評估手稿的準備情況。我們也準備了
                                            <a style="color: #0000ff;" (click)="scroll(viewVideo)" class="link">影片</a> 來説明您理解報告。</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        使用Trinka出版準備檢查功能來提高您的出版機會
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>從期刊選擇到道德合規等20多個檢查標準來評估您的文檔，幫助您提高出版的機會。</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他應用程式
                                    <br />中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/tw/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser">
                                            <h3>瀏覽器
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise apps">
                                            <h3 style="margin: 0 0 -2px 0;">企業</h3>
                                            <span style="font-size: 10px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/c8yyiW2tEjE"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>